import axios from './axiosService';
import {find} from 'lodash';


export default {
  getStatusCode(status) {
    let result = find(this.getStatusCodes(), c => c.id === status);
    if (!result) {
      result = find(this.getStatusCodes(), c => c.id === 'unknown');
    }
    return result;
  },
  getStatusCodes() {
    return [
      {
        id: 'TBD',
        text: 'TBD',
        tooltip: 'To be determined',
        color: 'warning',
        darkMode: true,
        icon: 'fa-question-circle',
        description: 'We haven\'t checked this email address yet.',
      },
      {
        id: 'valid',
        text: 'Deliverable',
        tooltip: 'Valid',
        color: 'success',
        darkMode: true,
        icon: 'fa-check-circle',
        description: 'A valid email address has been verified as a real email that is currently accepting mail.',
      },
      { // MLD-6616
        id: 'overridden',
        text: 'Overridden',
        tooltip: 'Overridden',
        color: 'success',
        darkMode: true,
        icon: 'fa-check-circle',
        description: 'An overridden email address has been verified as valid even though it may have been flagged as invalid.',
      },
      {
        id: 'catchall',
        text: 'Probably',
        tooltip: 'Catch all',
        color: 'light-green lighten-1',
        darkMode: true,
        icon: 'fa-question-circle',
        description: 'This is also known as a “catch-all.” This is a domain-wide setting where all emails on this domain will be reported as an "accept all." There is no definitive way to determine whether this email is valid or invalid.',
      },
      {
        id: 'unknown',
        text: 'Probably',
        tooltip: 'Unknown',
        color: 'light-green lighten-2',
        darkMode: true,
        description: 'We are unable to determine the status of this email status definitively. This email appears OK; however, the domain and/or server are not responding to our requests. This may be due to an issue with their internal network or expired domain names. Unknown addresses are checked up to 75 times before this result code is given.',
      },
      {
        id: 'invalid',
        text: 'Not Deliverable',
        tooltip: 'Invalid',
        color: 'error',
        darkMode: true,
        icon: 'fa-exclamation-triangle',
        description: 'An invalid email address has been verified as a bad recipient address that does not exist or is not accepting mail. Invalid emails will result in a bounce.',
      },
      {
        id: 'disposable',
        text: 'Not Deliverable',
        tooltip: 'Disposable',
        darkMode: true,
        icon: 'fa-exclamation-triangle',
        description: 'Disposable emails are temporary accounts used to avoid using a real personal account during sign-up. Common providers of disposable emails include Mailinator, Guerilla Mail, AirMail, and 10 Minute Mail.',
      },
    ]
  },
  getLists() {
    return axios.get(`/api/neverbounce/email-lists`)
      .then(response => response.data);
  },
  getList(listID) {
    return axios.get(`/api/neverbounce/email-lists/${listID}`)
      .then(response => response.data);
  },
  parse(jobID, autoStart) {
    const form = {
      auto_start: autoStart
    }
    return axios.post(`/api/neverbounce/jobs/${jobID}/parse`, form)
      .then(response => response.data);
  },
  start(jobID) {
    return axios.post(`/api/neverbounce/jobs/${jobID}/start`)
      .then(response => response.data);
  },
  analyze(jobID) {
    return axios.post(`/api/neverbounce/jobs/${jobID}/analyze`)
      .then(response => response.data);
  },
  checkStatus(listID) {
    return axios.get(`/api/neverbounce/email-lists/${listID}/status`)
      .then(response => response.data);
  },
  verify(email) {
    const form = {
      email: email
    };
    return axios.post(`/api/neverbounce/verify`, form)
      .then(response => response.data);
  },
  async deleteList(listID) {
    return axios.delete(`/api/neverbounce/email-lists/${listID}`)
      .then(response => response.data);
  },
  async downloadList(list) {
    const listID = list.id;
    const filename = list.results_filename;
    const response = await axios.get(`/api/neverbounce/email-lists/${listID}/download`)
    // https://stackoverflow.com/questions/43432892/force-download-get-request-using-axios
    const blob = new Blob([response.data], {type: 'text/csv'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  },
  search(form) { // MLD-6616
    return form.post(`/api/neverbounce/emails/search`)
      .then(response => response.data);
  },
}
